<template>
  <div class="bg-white rounded-lg m-3">
    <transition name="fade">
      <div
        v-if="create_error"
        class="p-1 text-center text-sm w-full bg-yellow-200"
      >
        {{ create_error }}
      </div>
    </transition>
    <transition name="fade">
      <div
        v-if="create_success"
        class="p-1 text-center text-sm w-full bg-green-200"
      >
        {{ create_success }}
      </div>
    </transition>
    <transition name="fade">
      <div
        v-if="del_error"
        class="p-1 text-center text-sm w-full bg-yellow-200"
      >
        {{ del_error }}
      </div>
    </transition>

    <transition name="fade">
      <div
        v-if="del_success"
        class="p-1 text-center text-sm w-full bg-green-200"
      >
        {{ del_success }}
      </div>
    </transition>
    <transition name="fade">
      <div
        v-if="get_error"
        class="p-1 text-center text-sm w-full bg-yellow-200"
      >
        {{ get_error }}
      </div>
    </transition>
    <transition name="fade">
      <div
        v-if="loading"
        class="inset-0 absolute bg-black rounded-md bg-opacity-40 w-full"
      >
        <loader class="center-h-v" />
      </div>
    </transition>
    <div class="border-b-0.5 flex justify-between items-center p-3">
      <p class="text-sm font-semibold">{{ title }}</p>
      <button
        @click="() => handleClick(title)"
        class="bg-primary text-white px-5 text-xs rounded-full py-2"
      >
        Upload
      </button>
    </div>

    <!--  @tab-click="getLeaveSummary" -->
    <el-tabs type="border-card" v-model="activeTab" @tab-click="handleTabClick">
      <el-tab-pane
        v-for="classification in documentClassifications"
        :key="classification.Id"
        :label="classification.Name"
        :id="classification.Id"
        :name="classification.Name"
      >
        <div
          class="grid lg:grid-cols-3 grid-cols-1 justify-start px-3 py-5 gap-x-1 gap-y-4 w-3/4 text-sm"
        >
          <div
            v-for="(file, index) in documentInfo[
              classification.Name.toLowerCase()
            ]"
            :key="index"
          >
            <div
              class="flex gap-3 rounded-full p-2 justify-between items-center whitespace-nowrap flex-nowrap"
            >
              <DocumentsDisplay
                :delete-document-callback="deleteDocument"
                :document="file"
                :openPDFViewer="openPDFViewer"
                :show-delete-icon="true"
                :displayWidth="72"
                :paddingX="2"
                :paddingY="1.5"
              ></DocumentsDisplay>
            </div>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>

    <AddDocument
      :close="handleClose"
      :showAddDocument="showAddDocument"
      @closeOnSuccess="handleCloseOnSuccess"
      :getMyDocuments="getMyDocuments"
      :itemIndex="itemIndex"
      :reload="reload"
      :getErrorMessage="getErrorMessage"
      :getSuccessMessage="getSuccessMessage"
      :flushMessages="flushMessages"
      :activeTab="activeTab"
    >
    </AddDocument>
    <attachments-viewer
      :showAttachments="showAttachments"
      :attachmentUrl="attachmentUrl"
      :attachmentType="attachmentType"
      @close="showAttachments = false"
      @closeOnSuccess="handleCloseOnSuccess"
      :docTitle="docTitle"
    ></attachments-viewer>
  </div>
</template>

<script>
import axios from "axios";
import AddDocument from "./modals/addDocument.vue";
import AttachmentsViewer from "@/utils/attachmentsViewer.vue";
import { mapGetters } from "vuex";
import DocumentsDisplay from "@/utils/documentsDisplay.vue";
import Loader from "@/components/loader/loader.vue";
import mergePDFs from "@/utils/createPdfBlob";
export default {
  name: "DocumentInfoCard",
  props: ["title", "data", "documentIndex"],
  components: {
    Loader,
    AddDocument,
    AttachmentsViewer,
    DocumentsDisplay,
  },
  data() {
    return {
      loading: false,
      showAddDocument: false,
      itemIndex: 0,
      showAttachments: false,
      attachmentUrl: "",
      error: null,
      showPDFViewer: false,
      pdfToView: null,
      docTitle: "Documents",
      del_error: null,
      get_error: null,
      attachmentType: "",
      del_success: null,
      create_success: null,
      create_error: null,
      myDocuments: [],
      documentClassifications: [],
      documentInfo: [],
      activeTab: "",
      isShowStatutory: false,
    };
  },
  computed: {
    ...mapGetters(["getToken", "getOrganization", "getCurrentEmployeeId"]),
  },
  created() {
    this.getDocumentClassifications();
    this.getMyDocuments();
  },
  methods: {
    handleTabClick({ _data }) {
      this.activeTab = this.documentClassifications[_data.index].Name;
      this.isShowStatutory =
        this.documentClassifications[_data.index].Name?.toLowerCase()?.includes(
          "statutor"
        );
    },
    handleDeleteDocument() {},
    flushMessages() {
      this.create_success = null;
      this.create_error = null;
    },
    getSuccessMessage(message) {
      this.create_success = message;
    },
    getErrorMessage(message) {
      this.create_error = message;
    },
    close() {
      this.showAddDocument = false;
      this.getMyDocuments();
    },
    reload() {
      this.showAddDocument = false;
      this.getMyDocuments();
    },
    handleSubmit() {
      setTimeout(() => {
        this.close();
      }, 1000);
    },

    handleClose() {
      this.showAddDocument = false;
    },
    handleClick(title) {
      this.showAddDocument = true;
      if (title.trim().toLowerCase() === "work documents") {
        this.itemIndex = 0;
      } else {
        this.itemIndex = 1;
      }
    },
    handleCloseOnSuccess() {
      this.showAddDocument = false;
      this.showLocCrSuccess = false;
      setTimeout(() => {
        this.showLocCrSuccess = false;
      }, 3000);
      this.getLeaveTypes();
    },
    // /{organization}/employee/document/{employeeDocumentId}/v1/delete
    deleteDocument({ EmployeeDocumentId }) {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      axios
        .delete(
          `${this.getOrganization}/employee/document/${EmployeeDocumentId}/v1/delete`,
          options
        )
        .then(
          (response) => {
            this.loading = false;
            if (response.data.StatusCode == 200) {
              this.del_success = response.data.StatusMessage;

              setTimeout(() => {
                this.del_success = null;
                this.reload();
              }, 2500);
            } else {
              this.del_error = response.data.StatusMessage;
              setTimeout(() => {
                this.del_error = null;
              }, 2500);
            }
          },
          (error) => {
            this.loading = false;
            this.del_error = error.message;
            setTimeout(() => {
              this.del_error = null;
            }, 2500);
          }
        );
    },

    openPDFViewer(documentUrl, title) {
      this.loading = true;
      const config = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
        responseType: "arraybuffer",
      };

      this.attachmentType = documentUrl;
      this.docTitle = title;

      axios
        .get(documentUrl, config)
        .then(async (response) => {
          this.loading = false;

          const contentDisposition = response.headers["content-disposition"];
          // console.log(response);
          if (contentDisposition) {
            const fileNameMatch = contentDisposition.match(/filename="(.+)"/);

            if (fileNameMatch && fileNameMatch[1]) {
              const originalFileName = fileNameMatch[1];
              console.log("Original file name:", originalFileName);
            }
          }
          // Check if the response data is a valid PDF
          if (response.headers["content-type"] === "application/pdf") {
            // Create a URL for the Blob
            const url = await mergePDFs(response.data);

            // Set the PDF URL to attachmentUrl
            this.attachmentUrl = url;
            // alert(url);
          } else {
            // If it's not a valid PDF, it is treated as an image
            const blob = new Blob([response.data], {
              type: response.headers["content-type"],
            });
            const url = URL.createObjectURL(blob);

            // Set the image URL to attachmentUrl
            this.attachmentUrl = url;
          }

          this.showAttachments = true;
        })
        .catch((error) => {
          this.loading = false;
          this.get_error = error;
          setTimeout(() => {
            this.get_error = null;
          }, 2500);
        });
    },

    getMyDocuments() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
          "Content-Type": "application/json",
        },
      };

      axios
        .get(
          `${this.getOrganization}/employee/${this.getCurrentEmployeeId}/document/${this.$ApiVersion}/request`,
          options
        )
        .then(
          (response) => {
            this.loading = false;
            if (response.data.StatusCode == 200) {
              this.myDocuments = response.data.Data;

              // Create an object to store documents by classification
              const documentsByClassification = {};

              // Filter documents dynamically based on available classifications
              this.documentClassifications.forEach((classification) => {
                const filteredDocuments = this.myDocuments.filter(
                  (doc) => doc.DocumentClassification === classification.Name
                );

                // Assign the filtered documents to the object with classification name
                documentsByClassification[classification.Name.toLowerCase()] =
                  filteredDocuments;
              });

              // Assign the entire object to a data property
              this.documentInfo = documentsByClassification;
            } else {
              this.create_error = response.data.StatusMessage;
            }
          },
          (error) => {
            this.loading = false;
            this.create_error = error.message;
          }
        );
    },

    async getDocumentClassifications() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };

      try {
        const response = await axios.get(
          `${this.getOrganization}/setup/document/classification/${this.$ApiVersion}/request`,
          options
        );

        if (response.data.StatusCode === 200) {
          this.documentClassifications = response.data.Data;
          this.activeTab = this.documentClassifications[0].Name;
          this.getMyDocuments();
        } else {
          this.get_error = response.data.StatusMessage;
        }
      } catch (error) {
        this.get_error = error.message;
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
